import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=23a9215c&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=23a9215c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9215c",
  null
  
)

export default component.exports